import { urlify } from '../utils/string';

export default (state = {}, action = {}) => {
	if (action.type === 'PRODUCT_CACHE') {
		// Create styleup tables.
		// Sorting done dynamically.

		// Name - Search
		const cache = action.productCache.content;
		const { languages, categories, categoryTitles, categoryTitlesLocalized } = action.productCache; // Languages WP setting not Centra.

		const filterArrays = {
			categories, // Object mapping category paths to arrays of product keys.
			colors: {}, // Object mapping color names to arrays of product keys.
			brands: {}, // Object mapping brands to arrays of product keys.
			materials: {}, // Object mapping sizes to arrays of product keys.
			productsOnSale: [], // Array of product keys
			newProducts: [], // Array of product keys
		};
		const filterDescriptions = {
			categories: categoryTitles,
			colors: {},
			brands: {},
			materials: {},
		};
		const languageKeys = Object.keys(languages).map((l) => l.toLowerCase());
		const searchTerms = languageKeys.reduce((acc, language) => ({ ...acc, [language]: {} }), {});

		const localized = languageKeys.slice(1).reduce((acc, language) => ({
			...acc,
			[language]: {
				categories: categoryTitlesLocalized ? categoryTitlesLocalized[language] : {},
				colors: {},
				materials: {},
			},
		}), {}); // Merged localized version of above.

		/*
			Localized versions shouldn't create new arrays.
			Their arrays exist but at their non-translated key.
			How to map their keys with their localized versions.
		*/

		Object.keys(cache).forEach((cacheKey) => {
			const item = cache[cacheKey];
			if (item.productHidden) return;

			// Category lookup
			// Categories straight from Centra

			// Colors lookup
			if (item.swatch_filter) {
				Object.keys(item.swatch_filter).forEach((colorKey) => {
					const colorItem = item.swatch_filter[colorKey];
					const colorItemUrlified = urlify(colorItem.desc);

					if (!filterArrays.colors[colorItemUrlified]) {
						filterArrays.colors[colorItemUrlified] = [];
						filterDescriptions.colors[colorItemUrlified] = colorItem;
					}
					filterArrays.colors[colorItemUrlified][filterArrays.colors[colorItemUrlified].length] = cacheKey;
				});
			}

			// Materials lookup
			if (item.material) {
				Object.keys(item.material).forEach((materialKey) => {
					const materialItem = item.material[materialKey];
					const materialItemUrlified = urlify(materialItem);

					if (!filterArrays.materials[materialItemUrlified]) {
						filterArrays.materials[materialItemUrlified] = [];
						filterDescriptions.materials[materialItemUrlified] = materialItem;
					}
					filterArrays.materials[materialItemUrlified][filterArrays.materials[materialItemUrlified].length] = cacheKey;
				});
			}

			// Search Terms
			searchTerms[languageKeys[0]][`${item.name} ${item.variantName}`] = searchTerms[languageKeys[0]][`${item.name} ${item.variantName}`] ? [...searchTerms[languageKeys[0]][`${item.name} ${item.variantName}`], cacheKey] : [cacheKey];

			if (languageKeys.length > 1) {
				languageKeys.slice(1).forEach((language) => {
					const isoLanguageCode = language;
					const localizedItem = item.localized ? item.localized[isoLanguageCode] : false;

					// Can't create localized versions if default doesn't exist.
					if (localizedItem && localizedItem.swatch_filter) {
						Object.keys(localizedItem.swatch_filter).forEach((colorKey) => {
							// Color key should exist on default as impossible to create localized version without default.
							localized[isoLanguageCode].colors[urlify(item.swatch_filter[colorKey])] = {
								key: urlify(localizedItem.swatch_filter[colorKey]),
								description: localizedItem.swatch_filter[colorKey],
							};
						});
					}
					// Can't create localized versions if default doesn't exist.
					if (localizedItem && localizedItem.material) {
						Object.keys(localizedItem.material).forEach((materialKey) => {
							// Material key should exist on default as impossible to create localized version without default.
							localized[isoLanguageCode].materials[urlify(item.material[materialKey])] = {
								key: urlify(localizedItem.material[materialKey]),
								description: localizedItem.material[materialKey],
							};
						});
					}

					if (localizedItem && localizedItem.name) {
						searchTerms[isoLanguageCode][localizedItem.name + localizedItem.variantName] = searchTerms[isoLanguageCode][localizedItem.name + localizedItem.variantName] ? [...searchTerms[isoLanguageCode][localizedItem.name + localizedItem.variantName], cacheKey] : [cacheKey];
					} else {
						searchTerms[isoLanguageCode][item.name + item.variantName] = searchTerms[isoLanguageCode][item.name + item.variantName] ? [...searchTerms[isoLanguageCode][item.name + item.variantName], cacheKey] : [cacheKey];
					}
				});
			}

			// Brands lookup
			if (!filterArrays.brands[urlify(item.brand)]) {
				filterArrays.brands[urlify(item.brand)] = [];
				filterDescriptions.brands[urlify(item.brand)] = item.brand;
			}
			filterArrays.brands[urlify(item.brand)][filterArrays.brands[urlify(item.brand)].length] = cacheKey;

			// Sale / News
			if (item.price.showAsOnSale) filterArrays.productsOnSale[filterArrays.productsOnSale.length] = cacheKey;
			if (item.price.newProduct) filterArrays.newProducts[filterArrays.newProducts.length] = cacheKey;
		});

		/*
			Extend search terms.
		*/

		// Categories
		Object.keys(filterDescriptions.categories).forEach((category) => {
			const categorySearchTerm = searchTerms[languageKeys[0]][filterDescriptions.categories[category]];
			searchTerms[languageKeys[0]][filterDescriptions.categories[category]] = !categorySearchTerm ? filterArrays.categories[category] : [...categorySearchTerm, ...filterArrays.categories[category]];

			if (languageKeys.length > 1) {
				languageKeys.slice(1).forEach((language) => {
					if (localized[language] && localized[language].categories && localized[language].categories[category]) {
						const localizedCategorySearchTerm = searchTerms[language][localized[language].categories[category].description];
						searchTerms[language][localized[language].categories[category].description] = !localizedCategorySearchTerm ? filterArrays.categories[category] : [...localizedCategorySearchTerm, ...filterArrays.categories[category]];
					} else {
						const localizedCategorySearchTerm = searchTerms[language][filterDescriptions.categories[category]];
						searchTerms[language][filterDescriptions.categories[category]] = !localizedCategorySearchTerm ? filterArrays.categories[category] : [...localizedCategorySearchTerm, ...filterArrays.categories[category]];
					}
				});
			}
		});

		// Brands
		Object.keys(filterDescriptions.brands).forEach((brand) => {
			const brandSearchTerm = searchTerms[languageKeys[0]][filterDescriptions.brands[brand]];
			searchTerms[languageKeys[0]][filterDescriptions.brands[brand]] = !brandSearchTerm ? filterArrays.brands[brand] : [...brandSearchTerm, ...filterArrays.brands[brand]];

			if (languageKeys.length > 1) {
				languageKeys.slice(1).forEach((language) => {
					// Copy default language
					searchTerms[language][filterDescriptions.brands[brand]] = [...searchTerms[languageKeys[0]][filterDescriptions.brands[brand]]];
				});
			}
		});

		// Colors
		Object.keys(filterDescriptions.colors).forEach((color) => {
			const searchTerm = filterDescriptions.colors[color].description;
			const colorSearchTerm = searchTerms[languageKeys[0]][searchTerm];
			searchTerms[languageKeys[0]][searchTerm] = !colorSearchTerm ? filterArrays.colors[color] : [...colorSearchTerm, ...filterArrays.colors[color]];

			if (languageKeys.length > 1) {
				languageKeys.slice(1).forEach((language) => {
					if (localized?.[language]?.colors?.[color]) {
						const localizedColorSearchTerm = searchTerms[language][localized[language].colors[color].description];
						searchTerms[language][localized[language].colors[color].description] = !localizedColorSearchTerm ? filterArrays.colors[color] : [...localizedColorSearchTerm, ...filterArrays.colors[color]];
					} else {
						const localizedColorSearchTerm = searchTerms[language][searchTerm];
						searchTerms[language][searchTerm] = !localizedColorSearchTerm ? filterArrays.colors[color] : [...localizedColorSearchTerm, ...filterArrays.colors[color]];
					}
				});
			}
		});

		// Materials
		Object.keys(filterDescriptions.materials).forEach((material) => {
			const materialSearchTerm = searchTerms[languageKeys[0]][filterDescriptions.materials[material]];
			searchTerms[languageKeys[0]][filterDescriptions.materials[material]] = !materialSearchTerm ? filterArrays.materials[material] : [...materialSearchTerm, ...filterArrays.materials[material]];

			if (languageKeys.length > 1) {
				languageKeys.slice(1).forEach((language) => {
					if (localized[language] && localized[language].materials && localized[language].materials[material]) {
						const localizedMaterialSearchTerm = searchTerms[language][localized[language].materials[material].description];
						searchTerms[language][localized[language].materials[material].description] = !localizedMaterialSearchTerm ? filterArrays.materials[material] : [...localizedMaterialSearchTerm, ...filterArrays.materials[material]];
					} else {
						const localizedMaterialSearchTerm = searchTerms[language][filterDescriptions.materials[material]];
						searchTerms[language][filterDescriptions.materials[material]] = !localizedMaterialSearchTerm ? filterArrays.materials[material] : [...localizedMaterialSearchTerm, ...filterArrays.materials[material]];
					}
				});
			}
		});

		return {
			...state,
			[action.market]: {
				...state[action.market],
				[action.pricelist]: {
					products: cache,
					filterArrays,
					filterDescriptions,
					localized,
					searchTerms,
				},
			},
		};
	}

	return state;
};
